<div class="dialog-wrapper">
  <div class="flex-container" mat-dialog-title>
    <ng-content select="[headerLogo]"></ng-content>
    <h2 [innerHtml]="titleText"></h2>
    <ng-content select="[headerActions]"></ng-content>
    @if (!hideClose) {
      <button
        class="dialog-close-btn"
        type="button"
        tabindex="-1"
        (click)="onCloseClick()"
        mat-icon-button
        >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>
  <lcs-loading-overlay class="dialog-content-wrapper" [show]="isLoading">
    <mat-dialog-content [class.dialog-no-scroll-content]="overrideContentScroll" cdkScrollable>
      <ng-content select="[dialog-content]"></ng-content>
    </mat-dialog-content>
  </lcs-loading-overlay>
</div>
